import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useFormSubmit } from "./useFormSubmit";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";

export const usePreventiveIssueClose = ({id}) => {
    const dispatch = useDispatch();
    const formId = "feedbackForm"
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const reload = true;
    const error = useSelector((state) => state.sendForm.error);

    const fields = [
        {label: "Дата устранения", name: "elimination_completion_date", validationRules: {required: true}},
    ]

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const body = {
                data: {
                    type: "close-violation",
                    attributes: {
                        elimination_completion_date: formValues.elimination_completion_date
                    }
                }
            }

            console.log("Отправляемые данные:", body);
            const action = await dispatch(sendForm({body, url: `/surveys/close-violation/${id}`, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error;
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    console.log("useFeedbackForm вызван!");
    return {formId, loadingStatus, handleSend: handleSubmit}
}